exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prompt-logo[data-v-e8a6a3c6] {\n  letter-spacing: -3px;\n  font-size: 1.6rem;\n}\n.prompt-logo-mini[data-v-e8a6a3c6] {\n  font-size: 0.8rem;\n}\n.prompt-description[data-v-e8a6a3c6] {\n  margin-top: -0.5rem;\n  font-size: 0.75rem;\n}\n.size-mini[data-v-e8a6a3c6] {\n  max-width: 1.5rem;\n  min-width: 1.5rem;\n  max-height: 1.5rem;\n  min-height: 1.5rem;\n}\n.size-full[data-v-e8a6a3c6] {\n  max-width: 3rem;\n  min-width: 3rem;\n  max-height: 3rem;\n  min-height: 3rem;\n}\n.widget-overflow[data-v-e8a6a3c6] {\n  overflow-x: auto;\n  overflow-y: hidden;\n}", ""]);

// exports
